<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <br/>
      <app-font-selector (onChange)="onFontChanged($event, '', 'Label')" [setConfig]="{i_config: sceneItem}"></app-font-selector>
    </div>
  }
  <hr/>
  <hr/>
</div>
